export default __webpack_public_path__ + "static/media/events.79c61132.svg";